/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据项目来源查询当前分区全部座位列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  sectionId: number,
  showId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.SeatInfoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/seats/${showId}/${sectionId}/all`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
